import { Component, inject } from '@angular/core';
import { NgFor } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SoftwareService } from '../../../../core/services/software.service';

@Component({
  selector: 'app-software-home',
  standalone: true,
  imports: [NgFor, RouterLink],
  templateUrl: './software-home.component.html',
  styleUrl: './software-home.component.scss'
})
export class SoftwareHomeComponent {
  lines = inject(SoftwareService).getLines();
}
